import React from "react";
import style from "./userdocuments.module.css";
import dummy_docs from "../../../Assets/images/document_default.png";
import { useFetchAll } from "../../../custom/FetchApiHook";
import { DocApi } from "../../../App/api/document.apis";

const UserDocuments = ({ itemData }) => {
  const { value } = useFetchAll(() => DocApi.getDocument(itemData?._id));
  const documentData = value?.data;

  const noDocuments =
    !documentData || (Array.isArray(documentData) && documentData.length === 0);

  return (
    <div className={style.main}>
      {noDocuments ? (
        // Inside your Documents tab content (when no documents)
        <div className="flex flex-col items-center justify-center min-h-[300px] py-12 px-6 text-center">
          {/* Icon / Illustration area */}
          <div className="mb-6 text-gray-400">
            <svg
              className="w-20 h-20 mx-auto opacity-70"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>

          {/* Main message */}
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            No documents uploaded yet
          </h3>

          <p className="text-gray-500 max-w-md">
            This user hasn't submitted any documents. Once they do, they'll
            appear here.
          </p>

          {/* Optional subtle call-to-action or hint */}
          <p className="mt-6 text-sm text-gray-400">
            Documents may include: ID proof, address verification, licenses,
            etc.
          </p>
        </div>
      ) : (
        documentData.map((item) => (
          <div className={style.card} key={item?._id}>
            <div className="w-[50%] h-full">
              <img
                src={item?.image || dummy_docs}
                alt={item?.name}
                className="w-full rounded-md"
                width={400}
              />
            </div>

            <div style={{ marginTop: "0.6rem" }}>
              <h1
                style={{
                  color: "var(--text-color3)",
                  textTransform: "capitalize",
                }}
              >
                {item?.name}
              </h1>

              <p style={{ marginTop: "0.4rem", fontWeight: "600" }}>
                Expiry Date
              </p>
              <p style={{ marginTop: "0.4rem" }}>{item?.expiry_date}</p>

              <p style={{ marginTop: "0.4rem", fontWeight: "600" }}>
                Unique Code
              </p>
              <p style={{ marginTop: "1rem" }}>{item?.unique_code}</p>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default UserDocuments;
